import { render } from "./PresentationSectionSmallerImage.vue?vue&type=template&id=f7f3ad46&scoped=true"
import script from "./PresentationSectionSmallerImage.vue?vue&type=script&lang=js"
export * from "./PresentationSectionSmallerImage.vue?vue&type=script&lang=js"

import "./PresentationSectionSmallerImage.vue?vue&type=style&index=0&id=f7f3ad46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7f3ad46"]])

export default __exports__